import { createFileRoute } from '@tanstack/react-router';
import { FullSizeSpinner } from '@/components/ui/FullSizeSpinner';
import { getPlanQueryOptions } from '@/lib/queries/adaptive-planner/useGetPlanQuery';
import { getScenariosDatasetQueryOptions } from '@/lib/queries/adaptive-planner/useGetScenariosDatasetQuery';
import { getVirtualResourcesQueryOptions } from '@/lib/queries/adaptive-planner/useGetVirtualResourcesQuery';
import { getTeamsQueryOptions } from '@/lib/queries/teams/useGetTeamsQuery';
import i18n from '@/lib/translations/i18n';
import type { LoaderData } from '@/lib/types/common';

export const Route = createFileRoute(
  '/(app)/org/$org/adaptive-planner/plan/$planId/backlog/scenario',
)({
  loader: async ({ context: { queryClient }, params: { planId } }): Promise<LoaderData> => {
    const crumb = i18n.t('adaptivePlanner.topNav.breadcrumbs.scenarioComparison');
    const planNum = Number(planId);

    await queryClient.ensureQueryData(getPlanQueryOptions({ planId: planNum }));
    await queryClient.ensureQueryData(getTeamsQueryOptions());
    await queryClient.ensureQueryData(getScenariosDatasetQueryOptions({ planId: planNum }));
    await queryClient.ensureQueryData(
      getVirtualResourcesQueryOptions({ planId: planNum, enabled: true }),
    );

    return {
      crumb,
    };
  },
  pendingComponent: FullSizeSpinner,
});
